// extracted by mini-css-extract-plugin
export var button = "Video-module--button--77b9b";
export var caption = "Video-module--caption--bbddf";
export var container = "Video-module--container--fdd93";
export var player = "Video-module--player--d830c";
export var video = "Video-module--video--36b9a";